import classNames from "classnames";
import React from "react";

export interface Props {
  type:
    | "visit_requested"
    | "visit_new"
    | "visit_viewed"
    | "task_viewed"
    | "task_new"
    | "visit_pending_confirmation";
  text: string;
  className?: string;
}

const EngagementLabel = (props: Props) => {
  return (
    <div data-type={props.type} className={classNames("EngagementLabel", props.className)}>
      {props.text}
    </div>
  );
};

export default EngagementLabel;
